// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"e411a3e2","316":"594bb93b","573":"f242ac6f","870":"fdfd8c2b","947":"533d7da4"}[chunkId] + ".chunk.css";
};